<script setup lang="ts">
import { useApplicationStore } from "@/stores/Application";
import { useUserStore } from "@/stores/User";
import { storeToRefs } from "pinia";

const appStore = useApplicationStore();
const { userFullName } = storeToRefs( useUserStore() );

function executeLogout() {
  appStore.logoutAndGoHome().then();
}
</script>


<template>
  <div class="flex items-center justify-between gap-2 p-3 bg-jade-600 text-base-100 border-b">
    <div class="text-lg">
      You are logged in as <b>{{ userFullName }}</b>
    </div>
    <button type="button" @click.prevent="executeLogout" class="btn btn-neutral btn-sm">
      Log Out
    </button>
  </div>
</template>
